export interface ParsianProviderSettings {
  merchantLoginAccount: string;
  rialToToman: boolean;
  blockOverseas: boolean;
}

export const DEFAULT_PARSIAN_PROVIDER_SETTINGS: ParsianProviderSettings = {
  merchantLoginAccount: '',
  rialToToman: true,
  blockOverseas: false
};

export function parseParsianProviderSettings(settingsJson: string | null | undefined): ParsianProviderSettings {
  if (!settingsJson?.trim()) {
    return { ...DEFAULT_PARSIAN_PROVIDER_SETTINGS };
  }

  try {
    const parsed = JSON.parse(settingsJson) as Partial<ParsianProviderSettings>;
    return {
      merchantLoginAccount: (parsed.merchantLoginAccount ?? '').trim(),
      rialToToman: parsed.rialToToman ?? true,
      blockOverseas: parsed.blockOverseas ?? false
    };
  } catch {
    return { ...DEFAULT_PARSIAN_PROVIDER_SETTINGS };
  }
}

export function serializeParsianProviderSettings(settings: ParsianProviderSettings): string {
  return JSON.stringify({
    merchantLoginAccount: settings.merchantLoginAccount.trim(),
    rialToToman: settings.rialToToman,
    blockOverseas: settings.blockOverseas
  });
}

/** Pure validation for enable/save button state (no signal writes). */
export function isParsianProviderSettingsValid(settings: ParsianProviderSettings): boolean {
  const value = settings.merchantLoginAccount.trim();
  if (!value) {
    return false;
  }
  return /^[0-9a-fA-F-]{36}$/.test(value);
}
